import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MealcheckInformationsBandComponent } from '@components/MealcheckInformationsBand/MealcheckInformationsBand';
import { RouterOutlet } from '@angular/router';
import { PromptService } from '@services/prompt.service';
import { ModalUserPreferencesComponent } from '@components/Modals/modal-user-preferences/modal-user-preferences.component';
import { SyncProcessingOverlayComponent } from '@components/sync-processing-overlay.component';

@Component({
  selector: 'app-base-layout',
  templateUrl: './base.layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MealcheckInformationsBandComponent,
    RouterOutlet,
    ModalUserPreferencesComponent,
    SyncProcessingOverlayComponent,
  ],
})
export class BaseLayoutComponent implements OnInit {
  @ViewChild('body', { static: true }) bodyElement!: any;

  protected showSettingsModal: boolean = false;

  constructor(private promptService: PromptService) {}

  ngOnInit(): void {
    this.promptService.registerHost(this.bodyElement.nativeElement);
  }
}
